<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="month" placeholder="选择月" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="订单号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="huohao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="颜色" min-width="100" prop="yanse"></el-table-column>
          <el-table-column align="center" label="序号" min-width="100" prop="xuhao"></el-table-column>
          <el-table-column align="center" label="物料名称" min-width="100" prop="wuliaomingcheng"></el-table-column>
          <el-table-column align="center" label="物料规格" min-width="100" prop="wuliaoguige"></el-table-column>
          <el-table-column align="center" label="材质" min-width="100" prop="caizhi"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          <el-table-column align="center" label="物料标准量" min-width="100" prop="biaozhunliang"></el-table-column>
          <el-table-column align="center" label="单根面积" min-width="100" prop="dangenmianji"></el-table-column>
          <el-table-column align="center" label="成控工价装框" min-width="100" prop="chengkongzhuangkuang"></el-table-column>
          <el-table-column align="center" label="成控工价淋洗" min-width="100" prop="chengkonglinxi"></el-table-column>
          <el-table-column align="center" label="执行工价装框" min-width="100" prop="zhixingzhuangkuang"></el-table-column>
          <el-table-column align="center" label="执行工价淋洗" min-width="100" prop="zhixinglinxi"></el-table-column>
          <el-table-column align="center" label="期初外协/库存数量" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          <el-table-column align="center" v-for="(item,index) in listObj" :key="index"
            :label="item" min-width="100" :prop="item"></el-table-column>
          <el-table-column align="center" label="订单欠量" min-width="100" prop="dingdanqianliang"></el-table-column>
          <el-table-column align="center" label="本月外协/库存数量" min-width="100" prop="benyuekucun"></el-table-column>
          <el-table-column align="center" label="本月淋洗产量" min-width="100" prop="benyuechanliang"></el-table-column>
          <el-table-column align="center" label="本月淋洗面积" min-width="100" prop="benyuelinximianji"></el-table-column>
          <el-table-column align="center" label="累计外协/库存数量" min-width="100" prop="leijikucun"></el-table-column>
          <el-table-column align="center" label="累计产量" min-width="100" prop="leijichanliang"></el-table-column>
          <el-table-column align="center" label="本月执行金额" min-width="150" prop="benyuezhixing"></el-table-column>
          <el-table-column align="center" label="本月成控金额" min-width="150" prop="benyuechengkong"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
      listObj: [],
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
    
    
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Yueribaoexcel/yuerblinxiExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '涂装淋洗日报汇总表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/Yueribao/yuerblinxi', data).then((res) => {
        this.list = res.data.data
        this.listObj = res.data.listObj
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
